<template>
  <main class="branch">
    <div class="notifications">
      <div v-for="notification in notifications" class="message message--success">
        <h3 class="message__title">{{ notification.title }}</h3>
        <p class="message__content">{{ notification.message }}</p>
      </div>
    </div>
    <router-view class="view"></router-view>
  </main>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'branch',
  computed: {
    ...mapGetters({
      notifications: 'allNotifications'
    })
  }
}
</script>

<style lang="scss">
@import '~sass/tools';

.branch {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.quadrant {
  width: calc(50% - .5rem);
  height: calc(42.5% - 2.25rem);
  margin-botom: 1.75rem;
  background-color: cc(bg);
  @include boxShadow;
}
</style>



// WEBPACK FOOTER //
// Branch.vue?4eaea6ae